module.exports = __webpack_public_path__ + "img/rosepetal-dep-aramatics.486bf81b.jpg";